<div class="container">
  <form [formGroup]="stepTwoForm">
    <div class="form-group">
      <div class="row mt-2">
        <div class="col-12 col-lg-6 mb-3">
          <label for="idcountry" style="font-weight: bold;">{{"SYSTEM.STEPTWO.INSTALLATIONCOUNTRY" | translate}}<sup
              class="small-asterisk">*</sup></label>
          <select class="form-select" aria-label="select example" formControlName="idcountry"
            [class.is-invalid]="stepTwoForm.get('idcountry')?.invalid && (stepTwoForm.get('idcountry')?.dirty || submitted)">
            <option [ngValue]="null" disabled selected>{{"SYSTEM.STEPTWO.SELECTCOUNTRY" | translate}}</option>
            <option *ngFor="let country of countriesData" [ngValue]="country.id">
              {{ country.common_name }}
            </option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepTwoForm.get('idcountry')?.invalid && (stepTwoForm.get('idcountry')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPTWO.COUNTRYERROR" | translate}}</div>
        </div>
        <div class="col-12 col-lg-6 mb-3">
          <label for="location_address" style="font-weight: bold;">{{"SYSTEM.STEPTWO.ADDRESS" | translate}}<sup
              class="small-asterisk">*</sup></label>
          <input type="text" name="location_address" id="location_address" formControlName="location_address"
            class="form-control" placeholder="{{'SYSTEM.STEPTWO.ADDRESS' | translate}}"
            [class.is-invalid]="stepTwoForm.get('location_address')?.invalid && (stepTwoForm.get('location_address')?.dirty || submitted)">
          <div class="text-danger mt-1"
            *ngIf="stepTwoForm.get('location_address')?.invalid && (stepTwoForm.get('location_address')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPTWO.ADDRESSERROR" | translate}}</div>
        </div>
        <div class="col-12 col-lg-6 mb-3">
          <label for="location_city" style="font-weight: bold;">{{"SYSTEM.STEPTWO.CITY" | translate}}<sup
              class="small-asterisk">*</sup></label>
          <input type="text" name="location_city" id="location_city" formControlName="location_city"
            class="form-control" placeholder="{{'SYSTEM.STEPTWO.CITY' | translate}}"
            [class.is-invalid]="stepTwoForm.get('location_city')?.invalid && (stepTwoForm.get('location_city')?.dirty || submitted)">
          <div class="text-danger mt-1"
            *ngIf="stepTwoForm.get('location_city')?.invalid && (stepTwoForm.get('location_city')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPTWO.CITYERROR" | translate}}</div>
        </div>
        <div class="col-12 col-lg-6 mb-3">
          <label for="location_postalcode" style="font-weight: bold;">{{"SYSTEM.STEPTWO.POSTALCODE" | translate}}<sup
              class="small-asterisk">*</sup></label>
          <input type="text" name="location_postalcode" id="location_postalcode" formControlName="location_postalcode"
            class="form-control" placeholder=""
            [class.is-invalid]="stepTwoForm.get('location_postalcode')?.invalid && (stepTwoForm.get('location_postalcode')?.dirty || submitted)">
          <div class="text-danger mt-1"
            *ngIf="stepTwoForm.get('location_postalcode')?.invalid && (stepTwoForm.get('location_postalcode')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPTWO.POSTALCODEERROR" | translate}}</div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <span style="font-size: medium;" [style]="{'color': (imagesStep2.length < 5 && submitted) ? 'red' : 'black'}">
          {{"SYSTEM.STEPTWO.INSTALLATIONPICTURES" | translate}}
        </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 text-center" data-bs-toggle="modal" data-bs-target="#exampleModal">
        <img class="imagePictures" src="assets/img/pictures.jpg">
      </div>
    </div>

    <div class="row justify-content-center mt-2">
      <ng-container *ngFor="let image2 of imagesStep2">
        <div *ngIf="image2.src" class="col-xs-12 col-sm-6 col-md-2 mb-4 text-center"
          style="width: 100px; height: 100px;">


          <ng-container *ngIf="image2.ext != 'pdf'; else pdfBlock">
            <ng-container *ngIf="isImageFile(image2.ext); else generic">
              <img [src]="urlServerLaraMedia + image2.src" [alt]="image2.title" class="img-fluid thumbnailImg"
                (click)="viewImage(image2)">
            </ng-container>
            <!-- If it's neither PDF nor a valid image extension, display a generic icon -->
            <ng-template #generic>
              <a [href]="urlServerLaraMedia+image2.src" target="_blank">
                <img src="assets/img/fileThumbnail.png" [alt]="image2.title" class="img-fluid thumbnailImg">
              </a>
            </ng-template>
          </ng-container>
          <ng-template #pdfBlock>
            <img src="assets/img/pdfThumbnail.png" [alt]="image2.title" class="img-fluid thumbnailImg"
              (click)="viewImage(image2)">
          </ng-template>

          <!-- <img *ngIf="image2.ext != 'pdf'; else pdfBlock" [src]="urlServerLaraMedia+image2.src" [alt]="image2.title"
            class="img-fluid thumbnailImg" (click)="viewImage(image2)">
          <ng-template #pdfBlock>
            <img src="assets/img/pdfThumbnail.png" [alt]="image2.title" class="img-fluid thumbnailImg"
              (click)="viewImage(image2)">
          </ng-template> -->
          <i class="bi bi-trash trash" (click)="deleteImg(image2.id)"></i>
        </div>
      </ng-container>
    </div>
    <div class="row justify-content-center mb-3 mt-2">
      <div class="col-md-4 text-center d-flex flex-column" style="max-width: 250px;">
        <label *ngIf="imagesStep2.length < 5 && submitted" class="text-danger" style="font-size: small;">
          {{"SYSTEM.STEPTWO.FEWIMAGES" | translate}}</label><br>
        <label *ngIf="!imageSpaceLeftStep2" class="text-danger" style="font-size: small;">
          {{"SYSTEM.STEPTWO.IMAGELIMIT" | translate}}
        </label><br>
        <label *ngIf="imagesStep2.length < maxImagesStep2" for="fileUpload2" class="btn btn-outline-dark mt-1">
          <i class="bi bi-upload" style="margin-right: 4px;"></i>
          {{"SYSTEM.STEPTWO.IMPORT" | translate}}
          <input type="file" id="fileUpload2" style="display: none;" (change)="onFileSelected($event)" multiple>
        </label>
      </div>
    </div>

    <!-- <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
        </mat-form-field> -->
    <div *ngIf="!isReadonly; else updateBlock" class="col-12 px-0 text-center">
      <button class="btn btn-outline-dark me-0 me-md-2" (click)="previous()">
        {{"SYSTEM.STEPBUTTONS.PREV" | translate}}
      </button>
      <button class="btn btn-outline-dark ms-1 me-1 ms-md-2 me-md-2" id="next" (click)="saveStep('save')">
        {{"SYSTEM.STEPBUTTONS.SAVE" | translate}}
      </button>
      <button class="btn btn-outline-dark me-0 ms-md-2" [disabled]="stepTwoForm.invalid || (imagesStep2.length < 5)"
        (click)="saveStep('next')">
        {{"SYSTEM.STEPBUTTONS.NEXT" | translate}}
      </button>
    </div>
    <ng-template #updateBlock>
      <div class="col-12 text-center">
        <button class="btn btn-outline-dark" (click)="approvalRequested()">
          {{"SYSTEM.STEPBUTTONS.UPDATE" | translate}}
        </button>
      </div>
    </ng-template>
  </form>
</div>

<!-- Visualizzazione immagine -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <img src="assets/img/pictures.jpg" style="width: 150%; height: auto;">
    </div>
  </div>
</div>
